import React from 'react';
import { AllieText } from "../../../components";

export const AllieTextColumn: React.FC<{ children: any }> = ({ children }) => (
  <AllieText type='field1' color='neutral-90'>{children}</AllieText>
);
